var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollarCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/dollar-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dollar-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.05859 8.35875C5.05859 9.11125 5.63609 9.71792 6.35359 9.71792H7.81776C8.44193 9.71792 8.94943 9.18708 8.94943 8.53375C8.94943 7.82208 8.64026 7.57125 8.17943 7.40792L5.82859 6.59125C5.36776 6.42792 5.05859 6.17708 5.05859 5.46542C5.05859 4.81208 5.56609 4.28125 6.19026 4.28125H7.65443C8.37193 4.28125 8.94943 4.88792 8.94943 5.64042",
    stroke: "#909DB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7 3.5V10.5",
    stroke: "#909DB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.99996 12.8327C10.2216 12.8327 12.8333 10.221 12.8333 6.99935C12.8333 3.77769 10.2216 1.16602 6.99996 1.16602C3.7783 1.16602 1.16663 3.77769 1.16663 6.99935C1.16663 10.221 3.7783 12.8327 6.99996 12.8327Z",
    stroke: "#909DB0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircle);
export default __webpack_public_path__ + "static/media/dollar-circle.1ab46eb9795975f032d8ab83a0a3db14.svg";
export { ForwardRef as ReactComponent };